/* AMC card image balance (draft 2026-10-22).
   Product photos ship with very different white margins, so some products look tiny in their cards.
   For cut-out photos on a white or transparent background, this measures the product's real outline
   (one small same-origin canvas read per image) and scales/centres it so every product fills the same
   share of its frame. Full-bleed photos (non-white corners) and cross-origin images are left as they are. */
(function () {
  'use strict';
  var SEL = '.amc-market-card__media img,.amc-cslider__imgwrap img,.card-wrapper .card__media img,.product-card-wrapper .card__media img';
  var FILL = 0.86, MAXS = 2.4, MINGAIN = 1.04;
  var cache = new WeakMap();

  function isBg(d, i) {
    var a = d[i + 3];
    if (a < 24) return true;
    return d[i] > 236 && d[i + 1] > 236 && d[i + 2] > 236;
  }
  function measure(img) {
    if (cache.has(img) && cache.get(img).src === img.currentSrc) return cache.get(img);
    var W = img.naturalWidth, H = img.naturalHeight, out = { src: img.currentSrc, ok: false };
    cache.set(img, out);
    if (!W || !H) return out;
    var w = 96, h = Math.max(1, Math.round(96 * H / W));
    if (h > 160) { h = 160; w = Math.max(1, Math.round(160 * W / H)); }
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var x = c.getContext('2d', { willReadFrequently: true });
    var d;
    try { x.drawImage(img, 0, 0, w, h); d = x.getImageData(0, 0, w, h).data; } catch (e) { return out; }
    var corners = [0, (w - 1) * 4, ((h - 1) * w) * 4, ((h - 1) * w + w - 1) * 4];
    for (var k = 0; k < 4; k++) if (!isBg(d, corners[k])) return out; /* full-bleed photo */
    var minX = w, minY = h, maxX = -1, maxY = -1;
    for (var yy = 0; yy < h; yy++) for (var xx = 0; xx < w; xx++) {
      if (!isBg(d, (yy * w + xx) * 4)) { if (xx < minX) minX = xx; if (xx > maxX) maxX = xx; if (yy < minY) minY = yy; if (yy > maxY) maxY = yy; }
    }
    if (maxX < 0) return out;
    out.ok = true;
    out.x0 = minX / w; out.x1 = (maxX + 1) / w; out.y0 = minY / h; out.y1 = (maxY + 1) / h;
    return out;
  }
  function fit(img) {
    /* Reviewed full-object homepage photos must never be automatically zoomed. */
    if (img.hasAttribute('data-amc-contain')) {
      img.style.setProperty('object-fit', 'contain', 'important');
      img.style.setProperty('object-position', 'center', 'important');
      img.style.setProperty('transform', 'none', 'important');
      return;
    }
    if (!img.complete || !img.naturalWidth) return;
    var m = measure(img);
    if (!m.ok) { img.style.removeProperty('transform'); return; }
    var Ew = img.clientWidth, Eh = img.clientHeight;
    if (!Ew || !Eh) return;
    var W = img.naturalWidth, H = img.naturalHeight;
    var fitMode = getComputedStyle(img).objectFit;
    var k = fitMode === 'cover' ? Math.max(Ew / W, Eh / H) : Math.min(Ew / W, Eh / H);
    var ox = (Ew - W * k) / 2, oy = (Eh - H * k) / 2;
    var cw = (m.x1 - m.x0) * W * k, ch = (m.y1 - m.y0) * H * k;
    var cx = ox + (m.x0 + m.x1) / 2 * W * k, cy = oy + (m.y0 + m.y1) / 2 * H * k;
    var s = Math.min(Ew * FILL / cw, Eh * FILL / ch, MAXS);
    if (s < MINGAIN) s = 1;
    var dx = Ew / 2 - cx, dy = Eh / 2 - cy;
    if (s === 1 && Math.abs(dx) < 2 && Math.abs(dy) < 2) { img.style.removeProperty('transform'); return; }
    img.style.setProperty('transform-origin', '50% 50%', 'important');
    img.style.setProperty('transform', 'scale(' + s.toFixed(3) + ') translate(' + dx.toFixed(1) + 'px,' + dy.toFixed(1) + 'px)', 'important');
    img.setAttribute('data-amc-fit', s.toFixed(2));
    /* keep enlarged photos sharp: ask the srcset for a file sized to the zoomed width */
    if (s > 1.12 && img.srcset) { var want = Math.ceil(Ew * s) + 'px'; if (img.getAttribute('sizes') !== want) img.setAttribute('sizes', want); }
    var p = img.parentElement; if (p && getComputedStyle(p).overflow === 'visible') p.style.overflow = 'hidden';
  }
  function all() { document.querySelectorAll(SEL).forEach(function (img) { if (img.complete) fit(img); }); }
  document.addEventListener('load', function (e) { var t = e.target; if (t && t.tagName === 'IMG' && t.matches(SEL)) fit(t); }, true);
  var rt; addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(all, 150); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all, { once: true }); else all();
  addEventListener('load', all, { once: true });
  setTimeout(all, 2500);
  document.addEventListener('shopify:section:load', all);
})();
